import { render, staticRenderFns } from "./ChooseTheme.vue?vue&type=template&id=7867fc7f&scoped=true"
import script from "./ChooseTheme.vue?vue&type=script&lang=js"
export * from "./ChooseTheme.vue?vue&type=script&lang=js"
import style0 from "./ChooseTheme.vue?vue&type=style&index=0&id=7867fc7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7867fc7f",
  null
  
)

export default component.exports